import type { RequestOwner } from '@/api/types';

/** Clients and warehouses for the filter bar, from the seller's own request options (never anything it does not own). */
export function filterOptions(owners: readonly RequestOwner[]): {
  readonly owners: readonly { value: string; label: string }[];
  readonly warehouses: readonly { value: string; label: string }[];
} {
  const wh = new Map<string, string>();
  for (const o of owners) for (const w of o.warehouses) if (!wh.has(w.id)) wh.set(w.id, w.name);
  return {
    owners: owners.map((o) => ({ value: o.id, label: o.name })),
    warehouses: [...wh].map(([value, label]) => ({ value, label })),
  };
}
